import axios from 'axios'
import store from './../store/store'
export default () => {
  const axiosConf = axios.create({
    //baseURL :  'http://localhost:5004/apicloud/',
    baseURL: process.env.VUE_APP_API_URL, //
    headers: {
      'Accept': 'application/json'
    }
  })  
  if (process.env.VUE_APP_RTEK8DSR) {axiosConf.defaults.headers['apikey'] = process.env.VUE_APP_RTEK8DSR}
  if (process.env.VUE_APP_BJ7DC3S) {axiosConf.defaults.headers['paraphrase'] = process.env.VUE_APP_BJ7DC3S}
  // axiosConf.defaults.headers['apikey'] = "***REMOVED-BY-AV-376-7***"
  // axiosConf.defaults.headers['paraphrase'] = "***REMOVED-BY-AV-376-7***"
  
  if (store.state && store.state.token) {axiosConf.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.token}
  axiosConf.defaults.headers.post['Content-Type'] = 'application/json'
  return axiosConf
}
